import { useMemo } from "react";
import MovieCard from "@/components/feature/MovieCard";
import { movies } from "@/mocks/movies";
import type { Movie } from "@/mocks/movies";

interface RelatedMoviesProps {
  current: Movie;
}

export default function RelatedMovies({ current }: RelatedMoviesProps) {
  const related = useMemo(() => {
    const scored = movies
      .filter((m) => m.id !== current.id)
      .map((m) => ({
        movie: m,
        overlap: m.genres.filter((g) => current.genres.includes(g)).length,
      }))
      .sort((a, b) => b.overlap - a.overlap || b.movie.score - a.movie.score);
    return scored.slice(0, 4).map((s) => s.movie);
  }, [current]);

  if (related.length === 0) return null;

  return (
    <section className="mt-12" aria-label="相关推荐">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="font-label text-sm font-medium text-accent-600">延伸观看</p>
          <h2 className="mt-1.5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">相关推荐</h2>
          <p className="mt-1.5 text-sm text-foreground-600">根据类型标签为你匹配的同类型高清影视作品。</p>
        </div>
      </div>
      <div className="mt-5 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
        {related.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}